<template>
  <v-alert v-if="showPaymentLockedAlert"
           elevation="2"
           color="info"
           text
           outlined
           icon="mdi-information">
    <div class="d-flex align-center flex-wrap" style="gap:2rem">
      <div style="flex: 1 1 600px">
        {{ $t('page.manageFiling.lockedForPayment.description') }}
      </div>
      <div style="flex: 0 0 auto">
        <v-btn color="info" @click="$emit('unlockFiling');">
          {{ $t('page.manageFiling.unlockFiling') }}
        </v-btn>
      </div>
    </div>
  </v-alert>
</template>

<script>
import _ from 'lodash';
import { useFilingStore } from '@/stores/filingStore';

const filingStore = useFilingStore();

export default {
  computed: {
    filing () {
      return filingStore.filing;
    },
    showPaymentLockedAlert () {
      return _.get(this.filing, 'filingStatus.resourceID', null) === this.CONST.FILING_STATUS_PENDING_PAYMENT;
    }
  }
};
</script>